module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingBonus/images/landing-bonus-ico-gold-large.RU.596d171e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingBonus/images/landing-bonus-ico-gold-large.RU.png
// module id = 3111
// module chunks = 11